import { Box, Container } from '@mui/material';
import {
  CollaborationOptionsSection,
  LetsCollaborateCallToAction,
  LetsCollaborateHeader,
} from '../components/LetsCollaborate/index.js';
import { useRsmTheme } from '../hooks/useTheme.js';
import { ContentPageLayout } from '../layouts';

/**
 * Let's Collaborate page - Hub for collaboration opportunities
 *
 * @returns {React.ReactElement} Let's Collaborate page component
 */
function LetsCollaborate() {
  const { colors } = useRsmTheme();

  return (
    <ContentPageLayout backgroundColor={colors.backgroundLight}>
      <Box
        sx={{
          minHeight: '100vh',
          pt: 12,
          pb: 8,
        }}
      >
        <LetsCollaborateHeader />

        <Container maxWidth="lg">
          <CollaborationOptionsSection />

          <LetsCollaborateCallToAction />
        </Container>
      </Box>
    </ContentPageLayout>
  );
}

export default LetsCollaborate;
